<template>
  <div class="fe-area" :class="layout" >
      <el-form-item class="fe-area-item" :class="{ 'form-group--error': $v.defaultValue.$error }" :label="'省份'" v-if="level > 0">
          <el-select :disabled="disabled" class="fe-select-content" @change="getCity(areaItem.provinceValue, 'city')" v-model="areaItem.provinceValue"  placeholder="请选择" value-key='regionCode'>
            <el-option v-for="item in province" :key="item.regionCode" :value="item" :label="item.province"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item  class="fe-area-item" :label="'城市:'"  v-if="level > 1">
          <el-select :disabled="disabled" class="fe-select-content"@change="getCity(areaItem.cityValue, 'county')"  v-model="areaItem.cityValue" placeholder="请选择" value-key='regionCode'>
            <el-option v-for="item in areaItem.cityList" :key="item.regionCode" :value="item" :label="item.city"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item  class="fe-area-item" :label="'区县:'" v-if="level > 2">
          <el-select :disabled="disabled" class="fe-select-content" @change="getCity(areaItem.countyValue,  'town')"  v-model="areaItem.countyValue" placeholder="请选择" value-key='regionCode'>
            <el-option v-for="item in areaItem.countyList" :key="item.regionCode" :value="item" :label="item.county"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item  class="fe-area-item" :label="'镇/街道:'" v-if="level > 3">
          <el-select :disabled="disabled"  class="fe-select-content" @change="getCity(areaItem.townValue,  'village')"  v-model="areaItem.townValue" placeholder="请选择" value-key='regionCode'>
            <el-option v-for="item in areaItem.townList" :key="item.regionCode" :value="item" :label="item.town"></el-option>
          </el-select>
      </el-form-item>
      <el-form-item class="fe-area-item" :label="'村/居委会:'" v-if="level > 4">
          <el-select :disabled="disabled"  class="fe-select-content"  v-model="areaItem.villageValue" placeholder="请选择" value-key='regionCode'>
            <el-option v-for="item in areaItem.villageList" :key="item.regionCode" :value="item.village" :label="item.village"></el-option>
          </el-select>
      </el-form-item>
    <div class="el-form-item__error error_input" v-if="$v.defaultValue.$error">
      {{errorMessage}}
    </div>
  </div>
</template>
<script>
  import validateMixin from '../../mixins/validateMixin'
  import { methodPost } from '@/api/coupon.js'

  export default {
    name: 'fm-area',
    mixins: [validateMixin],
    props: {
      name: {
        type: String,
        required: true
      },
      value: {
        type: String
      },
      level: { // 省县区级别最大为5
        type: Number | String,
        default: 3
      },
      disabled: {
        type: Boolean,
        default: false
      },
      layout: { // 布局方式，垂直vertical 水平horizontal
        type: String,
        default: 'horizontal'
      }
    },
    data() {
      return {
        areaItem: {
          regionCode: '',
          provinceValue: '',
          cityValue: '',
          countyValue: '',
          townValue: '',
          villageValue: '',
          cityList: [],
          countyList: [],
          townList: [],
          villageList: [],
          province: []
        },
        province: [],
        defaultValue: ''
      }
    },
    computed: {
    },
    watch: {
      value(val) {
        if (!val) {
          this.reset()
        }
        this.defaultValue = val
      }
    },
    created() {
      // this.init()
      methodPost('/region/list', {}).then(res => {
        if (res.code === 0) {
          this.province = res.data
          this.areaItem = this.areaObj()
        }
      })
    },
    methods: {
      getCity(provinceValue, name) {
        this.areaItem.regionCode = provinceValue.regionCode
        let level = ''
        this.$emit('input', this.areaItem.regionCode)
        switch (name) {
          case 'city':
            level = 2
            this.areaItem.cityValue = ''
            this.areaItem.countyValue = ''
            this.areaItem.townValue = ''
            this.areaItem.villageValue = ''
            this.areaItem.countyList = []
            this.areaItem.townList = []
            this.areaItem.villageList = []
            break
          case 'county':
            level = 3
            this.areaItem.countyValue = ''
            this.areaItem.townValue = ''
            this.areaItem.villageValue = ''
            this.areaItem.townList = []
            this.areaItem.villageList = []
            break
          case 'town':
            level = 4
            this.areaItem.townValue = ''
            this.areaItem.villageValue = ''
            this.areaItem.villageList = []
            break
          case 'village':
            level = 5
            this.areaItem.villageValue = ''
            break
        }
        if (this.level === level - 1) { // 最后一级不必请求下一级的数据
          return
        }
        const obj = {
          'regionCode': provinceValue.regionCode,
          'level': level
        }
        methodPost('/region/list', obj).then(res => {
          if (res.code === 0) {
            const str = name + 'List'
            this.areaItem[str] = res.data
          } else {
            this.$message(res.message)
          }
        }).catch(errData => {
          this.$message('网络出错，再试试吧')
        })
      },
      reset() {
        this.areaItem.provinceValue = ''
        this.areaItem.cityValue = ''
        this.areaItem.countyValue = ''
        this.areaItem.townValue = ''
        this.areaItem.villageValue = ''
      },
      areaObj() {
        const obj = {
          regionCode: '',
          provinceValue: '',
          cityValue: '',
          countyValue: '',
          townValue: '',
          villageValue: '',
          cityList: [],
          countyList: [],
          townList: [],
          villageList: []
        }
        return obj
      }
    }
  }
</script>
<style type="text/scss" lang="scss" scoped>
  .fe-area{
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 5px;
    margin-bottom: 5px;
    .el-form-item {
      margin-bottom: 0px
    }
    &-item{
      width: 30%;
    }
    .fe-select-content {
      width: 178px;
    }
  }
  .horizontal{
    flex-direction: row;
  }
  .vertical{
    flex-direction: column;
  }

</style>



// WEBPACK FOOTER //
// src/components/FromBase/area.vue